import { z } from 'zod';
/**
 * D4 — le corps du `409` de `POST /sync/inspections`, **dans le domaine** et non dans l'API :
 * c'est de lui que dépend le geste de l'outbox, donc la survie d'un relevé. Recopié à la main
 * côté tablette, un littéral fautif se lirait comme un succès et effacerait la fiche.
 *
 * ⚠️ **Un `409` signifie toujours « rien n'est enregistré ».** L'invariant tient à un seul
 * endroit — ici — et il est ce qui rend la règle de l'outbox tenable en une ligne : `2xx` ⇒
 * l'envoi est chez nous, il se classe transmis ; `409` ⇒ il n'y est pas, un humain doit voir ;
 * le reste se rejoue. Un cas « déjà reçu » sort en `200 { replayed: true }`, jamais en `409`.
 */
export const depositConflictCodeSchema = z.enum([
    /** Contrôle verrouillé et rien de votre équipe n'y est rangé : le back-office doit trancher. */
    'inquiry_locked',
    /** La même clé d'envoi porte déjà une **autre** demande — rejeu détourné, bug d'outbox. */
    'idempotency_key_reused',
    /** Plafond de propositions atteint sur ce contrôle : un client qui boucle, pas une tournée. */
    'too_many_proposals',
    /**
     * L'organisation n'autorise pas à **ajouter une pièce jointe après transmission**
     * ([M35](../../../../docs/MODELE-DONNEES.md#m35)), et ce dépôt en ajoute une.
     *
     * ⚠️ **Le seul refus du modèle qui vienne d'un réglage et non d'un fait.** Ce n'est pas une
     * saisie douteuse qu'on jetterait — M21 dirait de l'enregistrer — mais une règle que GHP a
     * posée et que l'API applique. Elle n'y déroge que parce que l'invariant du `409` la rend sans
     * danger : **rien n'est enregistré**, l'outbox garde l'enveloppe et ses octets, l'agent lit le
     * motif, et le bureau rouvre le contrôle quand il le décide.
     */
    'attachments_after_submission_closed',
]);
export const depositConflictSchema = z.object({
    code: depositConflictCodeSchema,
    message: z.string(),
});
/**
 * Le nombre de propositions qu'une équipe peut ranger sur un même contrôle.
 *
 * Généreux exprès : deux tablettes, un brouillon reparti de zéro, une reprise après renvoi au
 * terrain — l'empilement légitime se compte sur les doigts. Ce plafond ne borne pas le métier,
 * il borne la boucle : sans lui, un jeton de tournée insère une ligne JSONB par clé, aussi vite
 * que la limite de débit le permet, et rien ne l'arrête puisque le statut ne bouge plus.
 */
export const MAX_PROPOSALS_PER_INQUIRY = 20;
//# sourceMappingURL=deposit-conflict.js.map